import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const HeroSection = ({ onStartJourney }) => {
  const { t } = useLanguage();

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image (Video placeholder for MVP) */}
      <div className="absolute inset-0 z-0 bg-cover bg-center" style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1676744846995-16b700a00d57?crop=entropy&cs=srgb&fm=jpg&q=85)'
      }}>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto hero-content">
        <div className="mb-6">
          <span className="inline-block px-6 py-2 bg-white/10 backdrop-blur-md rounded-full text-[#FAF9F7] text-sm uppercase tracking-widest mb-8">
            {t('heroTagline')}
          </span>
        </div>
        
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-[#FAF9F7] mb-6 leading-tight">
          {t('heroTitle')}
        </h1>
        
        <p className="text-xl sm:text-2xl md:text-3xl text-[#F5F3F0] mb-12 font-light tracking-wide">
          {t('heroSubtitle')}
        </p>
        
        <Button 
          onClick={onStartJourney}
          size="lg"
          className="bg-[#C4B5A0] hover:bg-[#6B4E37] text-white px-8 py-6 text-lg rounded-md transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          {t('startJourney')}
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 scroll-indicator">
        <div className="w-6 h-10 border-2 border-[#FAF9F7] rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#FAF9F7] rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};